import { Grid } from "@material-ui/core";
import React from "react";
import SwlNegative from "../SwlPositiveNegative/SwlNegative";
import CenterLayout from "../CenterLayout";
import SecondChart from "../SecondChart";
import ExploreRecent from "../Explore/components/ExploreRecent";
import LiteOrderTicket from "ui-component/cards/LiteOrderTicket";
import SummaryCard from "ui-component/cards/SummaryCard";
import SmartWatchListSummary from "../SwlPositiveNegative/components/SmartWatchListSummary";
import { gridSpacing } from "store/constant";

const SmartWatchListLayout = () => {
  return (
    <Grid container spacing={2.0} >
        <Grid item xs={10} alignItems="center">
            <SecondChart />
            <Grid container padding={1.0} />
            <SwlNegative />
        </Grid>

        <Grid item xs={2} alignItems="center">
            {/*
            <Grid container padding={1.0} />
            <SummaryCard />
            <Grid container padding={1.0} />
            <LiteOrderTicket />
            <Grid container padding={1.0} />
            <SmartWatchListSummary />
            <Grid container padding={1.0} />
            */}
            <ExploreRecent />
        </Grid>

    </Grid>
  );
};

export default SmartWatchListLayout;
